import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { HomeOutlined, LoginOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import Header from '../../common/Header';
import BackView from '../../common/BackView';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';
import './NoPage.css';
import {getText} from "../../utils/helper";

const NoPage = () => {
    const navigate = useNavigate();
    const lang = useSelector((state) => state.app.lang);

    return (
        <>
            <div className="landingHeader">
                <Header />
            </div>
            <div className="noPageWrapper">
                <BackView />
                <div className="heroFloatingIcon">
                    <Logo />
                </div>
                <div className="noPageContainer">
                    <div className="noPageContent">
                        <div className="noPageIcon">
                            <svg
                                width="120"
                                height="120"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                                    fill="#ef4444"
                                />
                            </svg>
                        </div>
                        <h1 className="noPageTitle">{getText('Страница не найдена', lang)}</h1>
                        <p className="noPageDescription">
                            {getText('Данная страница отсутствует или требуется доступ для её просмотра.', lang)}
                        </p>
                        <p className="noPageSubDescription">
                            {getText('Если вы считаете, что это ошибка, обратитесь в службу поддержки.', lang)}
                        </p>
                        <div className="noPageActions">
                            <Button
                                type="primary"
                                size="large"
                                icon={<HomeOutlined />}
                                onClick={() => navigate('/')}
                                className="noPageButton"
                            >
                                {getText('На главную', lang)}
                            </Button>
                            <Button
                                type="default"
                                size="large"
                                icon={<LoginOutlined />}
                                onClick={() => navigate('/login')}
                                className="noPageButton"
                            >
                                {getText('Войти', lang)}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NoPage;
